import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import useFetch from "../../../../hooks/useFetch";
import { Modal } from "@mui/material";
import AddBooks from "./modals/AddBooks";
import {
  DeleteOutline,
  MenuBookOutlined,
  AddRounded,
} from "@mui/icons-material";
import {
  SectionCard,
  EmptyState,
} from "../../../shares/dashboard/DashboardWidgets";

const BooksAssign = () => {
  const [books, setBooks] = useState([]);
  const [addBooks, setAddBooks] = useState(false);
  const [deleteId, setDeleteId] = useState(false);
  const [bookIds, setBookIds] = useState({
    book_ids: [],
  });
  const { Id } = useParams();

  useEffect(() => {
    setBookIds({ ...bookIds, book_ids: books?.map((book) => book.id) });
  }, [books]);

  const handleClose = () => {
    setAddBooks(false);
  };

  const handleDelete = (e) => {
    const idToRemove = e;
    setBookIds((prevState) => ({
      ...prevState,
      book_ids: prevState.book_ids.filter((id) => id !== idToRemove),
    }));
    deleteBooks.reFetch();
  };

  const getBooks = useFetch({
    method: "GET",
    url: `management/users/${Id}/user_books/`,
    noHeader: false,
    trigger: true,
    setter: setBooks,
  });

  const deleteBooks = useFetch({
    method: "PATCH",
    url: `management/users/${Id}/user_books/`,
    noHeader: false,
    trigger: false,
    caller: getBooks,
    data: bookIds,
  });

  return (
    <SectionCard
      title="جزوات اختصاص‌یافته"
      icon={MenuBookOutlined}
      actionLabel="افزودن جزوه"
      onActionClick={() => setAddBooks(true)}
    >
      {books.length > 0 ? (
        <div className="flex flex-wrap gap-sm">
          {books.map((book) => (
            <span
              key={book.id}
              className="inline-flex items-center gap-2xs rounded-pill border border-rule-subtle bg-surface-sunken py-2xs pe-md ps-2xs text-sm text-ink"
            >
              <button
                type="button"
                onClick={() => handleDelete(book.id)}
                aria-label={`حذف ${book.booksname}`}
                className="inline-flex h-[2.4rem] w-[2.4rem] items-center justify-center rounded-pill text-ink-subtle transition-colors duration-150 hover:bg-danger-soft hover:text-danger focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
              >
                <DeleteOutline sx={{ fontSize: "1.6rem" }} />
              </button>
              {book.booksname}
            </span>
          ))}
          <button
            type="button"
            onClick={() => setAddBooks(true)}
            className="inline-flex items-center gap-2xs rounded-pill bg-primary px-md py-2xs text-sm text-white transition-colors duration-150 hover:bg-primary-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
          >
            <AddRounded sx={{ fontSize: "1.6rem" }} />
            افزودن جزوه
          </button>
        </div>
      ) : (
        <EmptyState
          icon={MenuBookOutlined}
          title="جزوه‌ای اختصاص داده نشده"
          description="برای این دانش‌آموز هنوز جزوه‌ای ثبت نشده است."
        />
      )}
      <Modal
        open={addBooks}
        onClose={handleClose}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <AddBooks
          close={handleClose}
          get={getBooks}
          Id={Id}
          bookList={books}
          setBookList={setBooks}
        />
      </Modal>
    </SectionCard>
  );
};

export default BooksAssign;
